import headerImage from "./assets/MC_headerimage.png";

/* =========================================================
   src/hero.jsx
   ========================================================= */

function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero-photo" aria-hidden="true">
        <img src={headerImage} alt="" />
      </div>
      <div className="wrap">
        <div className="hero-content">
          <h1 className="hero-title">
            Your guide to corporate <br /><em>digitalization.</em>
          </h1>
          <p className="hero-lede">
            We turn complex business challenges into 
            smart, fast, and secure digital solutions.
          </p>
          <div className="hero-ctas">
            <Button size="lg" onClick={() => smoothScrollTo("contact")}>
              Get in touch
              <Icon name="ArrowRight" size={16} className="btn-arrow" />
            </Button>
            <Button variant="ghost" size="lg" onClick={() => smoothScrollTo("services")}>
              Explore services
            </Button>
          </div>
          <div className="hero-stats">
            <Stat num="10+" label="Years in the field" />
            <Stat num="40" label="Transformations delivered" />
            <Stat num="EU" label="Based" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ num, label }) {
  return (
    <div className="stat">
      <div className="stat-num"><em>{num}</em></div>
      <div className="stat-label">{label}</div>
    </div>
  );
}

Object.assign(window, { Hero });
